import React from 'react';
import { filter, find, get, map } from 'lodash';

import { Button } from 'src/presentation/components/agent_desktop_components';
import { DnsRecord, DnsRecordType } from 'src/models/Email/EmailDomain';
import DnsRecordsTable from './DnsRecordsTable';
import generateId from 'src/lib/generateId';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { isLoadingStatus } from 'src/presentation/hooks/useResource';
import { StepDescription, StepWizardActionContainer, StepWizardField } from './StepWizardLayout';

export const DnsRecordsListForm = ({ item, onNextButtonClick, nextButtonName, loadingState }): JSX.Element => {
  const txtDnsRecords = filter(
    get(item, 'content.sendingDNSRecords'),
    (dnsRecords: DnsRecord) => dnsRecords.recordType === DnsRecordType.TXT
  );
  const dnsRecords = map(txtDnsRecords, dnsRecord => ({
    ...dnsRecord,
    authType: getEmailSecurityType(dnsRecord.value),
    id: generateId(),
  }));

  return (
    <>
      <StepWizardField>
        <H3 data-aid="wizard-title">Update your DNS records</H3>
        <StepDescription data-aid="wizard-description">
          Go to your DNS provider, most likely your web hosting service, for&nbsp;
          <b>{get(item, 'content.customerDomain')}</b> and add the following SPF and DKIM values. You may need to talk
          to your company&apos;s systems administrator for assistance.&nbsp;
          <ExternalLink
            data-aid="why-do-we-do-this-link"
            label="Why do we do this?"
            to="https://help.gladly.com/docs/email-setup-overview#spf-dkim-records"
          />
        </StepDescription>
      </StepWizardField>

      <DnsRecordsTable dnsRecords={dnsRecords} isLoading={isLoadingStatus(loadingState)} />

      <StepWizardActionContainer>
        <Button onClick={onNextButtonClick} data-aid="editor-save">
          {nextButtonName}
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

function getEmailSecurityType(txtRecord: string): string | undefined {
  const TYPES = {
    'v=spf1': 'SPF',
    'k=rsa': 'DKIM',
  };

  return find(TYPES, (_, key) => txtRecord.includes(key));
}

export default DnsRecordsListForm;
